import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Home.css';
import SEO from './SEO';
import { initializeTracker } from '../tracker_script.js';

const Home = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const navigate = useNavigate();

  const options = [
    { value: '', label: 'What are you interested in?', flag: '' },
    { 
      value: 'uae', 
      label: 'UAE Company Setup & Relocation', 
      flag: '🇦🇪',
      benefits: [
        'UAE residence visa included (renewable every 2 years)', 
        '0% tax residence with 90-day physical presence', 
        '0% corporate tax if total revenue below 3,000,000 AED, or 9% on profits if revenue above that'
      ],
      cost: 'Our all-inclusive service starts at $8,500 USD. (Total cost, not just the service fee)',
      timeline: 'Full process typically takes 2-4 weeks',
      ctaText: 'Book a FREE consultation',
      ctaLink: 'https://genzone.com/tk?website=tuomasHome'
    },
    { 
      value: 'uae-real-estate', 
      label: 'UAE Real Estate & Golden Visa', 
      flag: '🇦🇪',
      benefits: [
        'Invest 2,000,000 AED into property and get a 10-year UAE Golden Visa', 
        '0% tax residence with 90-day physical presence', 
        '5-8% rental yields',
        'UAE is a wealth magnet so strong capital appreciation is likely'
      ],
      cost: 'Minimum investment: $545,000 for golden visa',
      timeline: 'Property purchase and visa process takes 4-8 weeks',
      ctaText: 'Book a FREE consultation',
      ctaLink: 'https://genzone.com/tk?website=tuomasHome'
    },
    { 
      value: 'hong-kong', 
      label: 'Hong Kong Company Setup', 
      flag: '🇭🇰',
      benefits: [
        "0% corporate tax if your company won't operate from Hong Kong", 
        "World-class banking & business infrastructure", 
        "Easy access to the Chinese market"
      ],
      cost: 'Starting from 7458 for company registration & support - but you will get 16% off from my link below',
      timeline: '3-4 business days',
      ctaText: 'Form a Hong Kong Company',
      ctaLink: 'https://osome.com/hk/referral/16off/?ref=zmi2njgv&aff_name=Tuomas+Kiv&coupon=TKHK'
    },
    { 
      value: 'singapore', 
      label: 'Singapore Company Setup & Relocation', 
      flag: '🇸🇬',
      benefits: [
        'Residence permit (Employment Pass) in Singapore included', 
        'Low corporate & personal income taxes', 
        'Access to the freeest economy in the world', 
        'Excellent quality of life'
      ],
      cost: 'Starting from $2,896 for company setup & employment pass - but you will get 16% off from my link below',
      timeline: 'Company setup is completed in as little as 1 hour. Employment pass takes 6+ months.',
      ctaText: 'Get started',
      ctaLink: 'https://osome.com/sg/referral/incorporation/?ref=zmi2njgw&aff_name=Tuomas+Kiv&coupon=TK16'
    },
    { 
      value: 'us-llc', 
      label: 'US LLC setup', 
      flag: '🇺🇸',
      benefits: [
        '0% tax for non US-residents', 
        'Lowest USD payment processing fees & decline rates', 
        'US banking',
        'Very light maintenance'
      ],
      cost: '$1,000 for LLC formation',
      timeline: '48 hours for LLC formation, EIN & bank account opening',
      ctaText: 'Form a US LLC in 48 hours',
      ctaLink: 'https://genzone.com/usa-llc-tk/?website=tuomasHome'
    },
    {
      value: 'mexico',
      label: 'Mexico Permanent Residency',
      flag: '🇲🇽',
      benefits: [
        'Economic Solvency Residency Program',
        'Savings or investments required: $78,000 balance for past 12 months',
        'No need to live in Mexico',
        'Potential for citizenship with 2 years of residency after acquiring PR'
      ],
      cost: '$1,500 for professional assistance to navigate the process',
      timeline: 'Timeline varies by embassy and application type',
      ctaText: 'Learn More About Mexico Residency',
      ctaLink: '/mexico-residency'
    },
    {
      value: 'cbi',
      label: 'Citizenship by Investment',
      flag: '🌎',
      benefits: [
        'Get a second passport through investment',
        'No residency requirements for most programs',
        'Citizenship for life, can be passed to future generations'
      ],
      cost: 'Depends on the country',
      timeline: 'Processing takes 2-6 months depending on the country',
      ctaText: 'Apply for Citizenship by Investment',
      ctaLink: 'https://apply.vanciscapital.com/tuomas'
    },
    { 
      value: 'compare', 
      label: 'I am not sure, I would like to compare the options', 
      flag: '🔍',
      ctaText: 'View All Options',
      ctaLink: '/relocation-services'
    }
  ];

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
  };

  const handleButtonClick = (url) => {
    // For internal links
    if (url.startsWith('/')) {
      navigate(url);
    } else {
      // For external links
      window.open(url, '_blank');
    }
  };

  useEffect(() => {
    const usernameMeta = document.createElement('meta');
    usernameMeta.name = 'username';
    usernameMeta.content = 'user_2o6eptKfyuvEOe6kSTFVnGzxmMU';
    document.head.appendChild(usernameMeta);

    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'Website Home';
    document.head.appendChild(offerMeta);

    try {
      initializeTracker();
      console.log('Tracker initialized successfully');
    } catch (error) {
      console.error('Error initializing tracker:', error);
    }

    return () => {
      if (document.querySelector('meta[name="username"]')) {
        document.querySelector('meta[name="username"]').remove();
      }
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []);

  // Find the selected option object
  const selectedOptionData = options.find(option => option.value === selectedOption) || {};

  return (
    <div className="home-container">
      <SEO
        title="Tuomas - Expert Expat Relocation & International Business Setup"
        description="Professional expat relocation services by Tuomas: UAE company setup with 0% tax residence visa, Dubai Golden Visa, Mexico residency & citizenship, citizenship by investment, international tax optimization, and global business incorporation."
        keywords="Tuomas, expat relocation, UAE company setup, Dubai residence visa, 0% tax UAE, Dubai Golden Visa, Mexico residency, citizenship by investment, second passport, tax optimization, international business setup, expat services, global mobility"
        canonical="https://tuomaskivioja.com/"
        ogImage="https://tuomaskivioja.com/logo512.png"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Home - Tuomas",
          "description": "Expert expat relocation and international business setup services",
          "url": "https://tuomaskivioja.com/",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://tuomaskivioja.com/"
            }]
          }
        }}
      />
      <div className="profile-image-container">
        <img src="/tuomas.jpg" alt="Tuomas" className="profile-image" />
      </div>

      <div className="hero-section">
        <h1>Residence, company setup & real estate services</h1>
        <p>All services are offered via my certified partners who have been vetted to offer the best experience with 100s of previous case studies and a world-class track record.</p>
        
        <div className="dropdown-container">
          <select 
            value={selectedOption} 
            onChange={handleChange}
            className="interest-dropdown"
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label} {option.flag}
              </option>
            ))}
          </select>
        </div>

        {selectedOption && selectedOption !== 'compare' && (
          <div className="selected-option-details">
            <h2>{selectedOptionData.label} {selectedOptionData.flag}</h2>
            
            <div className="details-section">
              <div className="detail-item">
                <h3>Benefits:</h3>
                <ul className="benefits-list">
                  {selectedOptionData.benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
              
              <div className="detail-item">
                <h3>Cost:</h3>
                <p>{selectedOptionData.cost}</p>
              </div>
              
              <div className="detail-item">
                <h3>Timeline:</h3>
                <p>{selectedOptionData.timeline}</p>
              </div>
              
              <button 
                className="get-started-btn"
                onClick={() => handleButtonClick(selectedOptionData.ctaLink)}
              >
                {selectedOptionData.ctaText}
              </button>
            </div>
          </div>
        )}
        
        {selectedOption === 'compare' && (
          <div className="selected-option-details">
            <h2>Compare All Options {selectedOptionData.flag}</h2>
            <p>Let us help you find the best solution for your specific situation.</p>
            <button 
              className="get-started-btn"
              onClick={() => handleButtonClick(selectedOptionData.ctaLink)}
            >
              {selectedOptionData.ctaText}
            </button>
          </div>
        )}

        <div className="consultation-prompt">
          <p>Not sure which is the best setup for you? <Link to="/consultation">Book a consultation with Tuomas</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Home;